<template>
	<section id="lang-and-tools">
		<div class="container">
			<h3>Stacks</h3>
			<ul>
				<li>PHP (Symfony, Doctrine, Laravel)</li>
				<li>Python (Django, Flask, Bottle)</li>
				<li>Java (Spring, Hibernate)</li>
				<li>NodeJS (ExpressJs, NestJs)</li>
				<li>Linux (RedHat, Ubuntu)</li>
				<li>DevOps Tools (Ansible, LXC, GIT, Docker)</li>
				<li>Databases (MongoDB, XMLDBs/XQuery, PostgreSQL, MySQL, MSSQL)</li>
				<li>Javascript (AngularJS, Vue, jQuery, Typescript)</li>
			</ul>
		</div>
	</section>
</template>